import { Chip, TableCell } from "@mui/material";

export interface WizAssetRowData {
  id: string;
  orgId: string;
  orgName: string;
  status: string;
}

interface WizAssetRowProps {
  data: WizAssetRowData;
}

const WizAssetRow = ({ data }: WizAssetRowProps) => (
  <>
    <TableCell data-cy={`wiz-asset-orgid-${data.id}`}>{data.orgId}</TableCell>
    <TableCell data-cy={`wiz-asset-orgname-${data.id}`}>{data.orgName}</TableCell>
    <TableCell data-cy={`wiz-asset-status-${data.id}`}>
      {data.status === "active" ? (
        <Chip size="small" label="Active" color="success" data-cy="wiz-asset-status-active" />
      ) : (
        <Chip size="small" label="Inactive" color="error" data-cy="wiz-asset-status-inactive" />
      )}
    </TableCell>
  </>
);

export default WizAssetRow;
